module.exports = __webpack_public_path__ + "img/qr1.6f4bb272.png";